import { Component, OnInit, ViewChild } from '@angular/core';
import { RebateRequestComponent } from '../rebate-request/rebate-request.component';

@Component({
  selector: 'app-rebate-request-clone-request',
  templateUrl: './rebate-request-clone-request.component.html'
})

export class RebateRequestCloneRequestComponent implements OnInit {
  @ViewChild('rebateRequest',{static: false}) rebateRequest: RebateRequestComponent;

  constructor() { }

  ngOnInit() {}
  onRebateRequestLoadedFlag(flag: boolean) {
    if(flag){
      this.rebateRequest.editModeAdmin = true;
    }
  }
}
